import { NodeTypeName } from "@app/types";
import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";
import { Label } from "./label";

export default class Dropdown extends BaseComponent {
  /**
   * Dropdown with a selection menu of pre-defined options
   * @module Dropdown
   * @param {Object} props React props
   */
  constructor(props) {
    super(props);
    this.state = {
      wide: this.props.hasOwnProperty("wide") ? " wide" : "",
      query: "",
      readOnly: this.getReadOnly()
    };
    this.state.selection = (this.props.selection >= 0) ? (
      this.props.options[this.props.selection]
    ) : this.initDataModel();
    this.isMenuOpen = false;
    this.clickOutsideHandler = this.handleClickOutside.bind(this);
    this.eventHandler = this.handleEvent.bind(this);
    this.resetSelectedState = this.resetSelectedState.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isCommonModuleVersionDropdown) {
      if (nextProps.options[nextProps.selection] && nextProps.options[nextProps.selection].value !== this.state.selection.value) {
        this.setState({ selection: nextProps.options[nextProps.selection] })
      }
    }
    if (this.props.clearSelection) {
      this.setState({ selection: this.initDataModel() })
    }
    if (this.props.valKey === "ttsFallBackVoice" && nextProps.selection === -1) {
      this.setState({ selection: this.initDataModel() })
    }
    //show error message if props showError key is true 
    if (nextProps.showError) {
      this.setState({ selection: nextProps.options[nextProps.selection] })
      this.showErrorTip(this.props.errorMessage, "error");
    }
    if (!nextProps.showError && nextProps.options[nextProps.selection] && nextProps.options[nextProps.selection] !== this.state.selection) {
      this.setState({ selection: nextProps.options[nextProps.selection] })
      this.hideErrorTip();
    }
    else {
      if (nextProps.options[nextProps.selection] && nextProps.options[nextProps.selection] !== this.state.selection) {
        this.setState({ selection: nextProps.options[nextProps.selection] })
      }
    }
  }

  hasRemovable() {
    return this.props.hasOwnProperty("removable") && this.props.removable && this.state.selection && this.state.selection.value;
  }

  initDataModel() {
    return { name: this.getOptionName(), value: "" };
  }

  getReadOnly() {
    if (this.props.context && this.props.context.readOnly) {
      return true;
    } else if (this.props.readOnly) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Get the name for dropdown
   * @returns {string}
   */
  getOptionName() {
    return this.props.optionName ? this.props.optionName : this.getPropLabel("untitled");
  }

  /**
   * Get available options
   * @returns {Array}
   */
  getOptions() {
    return this.props.options ? this.props.options : [];
  }

  /**
   * Get reference to dropdown itself
   * @returns {jQuery}
   */
  getDomSelf() {
    return $(ReactDOM.findDOMNode(this)).children(".dropdown");
  }
  /**
   * Hide error message
   */
  hideErrorTip() {
    this.getDomSelf().removeClass("error").removeClass("warning");
    this.getErrorContainer().removeClass("error").removeClass("warning").html("&nbsp;").hide();
  }
  /**
   * Show error message
   */
  showErrorTip(tip, type = "error") {
    this.getErrorContainer().addClass(type).html(tip).show();
    this.getDomSelf().addClass(type).animateCss("shake");
    if (type === "warning") {
      // Auto hide warning after timeout
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(this.hideErrorTip.bind(this), 3000);
    }
  }
  /**
   * Get reference to the error message container
   * @returns {jQuery}
   */
  getErrorContainer() {
    return $(ReactDOM.findDOMNode(this)).children(".form-error-tip");
  }
  /**
   * Show the selection menu
   */
  showMenu() {
    if (this.props.hasOwnProperty("diagramWidget") && this.props.diagramWidget) {
      window.apm.postEventToCurrentView({ target: "request-hide-property-panel" });
    }
    this.getDomSelf().children(".dropdown-options").fadeIn(200).css("display", "table");
    this.getDomSelf().children(".dropdown-options").find("input:first").focus();
    this.isMenuOpen = true;
  }

  /**
   * Hide the selection menu
   */
  hideMenu() {
    this.getDomSelf().children(".dropdown-options").fadeOut(200).css("display", "none");
    this.isMenuOpen = false;
  }

  handleEvent(event) {
    if (this.hasRemovable() && event.type === "ev-property-dropdown-remove") {
      this.resetSelection();
    }
  }

  resetSelectedState() {
    this.setState({ selection: this.props.options[this.props.selection] });
  }

  /**
   * Handle click on selection menu items
   * @param {Object} target React current event target
   */
  async handleClick(target) {
    const listIdx = parseInt(target.dataset.id);

    this.setState({ selection: this.props.options[listIdx] });

    // CM TODO: usa w2popup with component content (e.g., <CommonModuleChangeVersionDialog />)
    if (this.props.isCommonModuleVersionDropdown) {
      const selectedCommonModuleVersion = this.props.options[listIdx].value;
      this.props.popupFunc(selectedCommonModuleVersion, this.props.context);
      return;
    }

    // cannot find `updatePromptText` as a prop in any file
    if (this.props.updatePromptText) {
      console.error('unsupported code path')
      document.dispatchEvent(new CustomEvent("ev-property-refresh"));
    }

    if (this.props.type === "view") {
      var canvasEv = new CustomEvent('ev-canvas-view-change', { detail: this.props.options[listIdx].value });
      document.dispatchEvent(canvasEv);
      window.apm.postEventToCurrentView({
        target: "request-change-view",
        event: { view: this.props.options[listIdx].value }
      });
    } else {
      this.updateContext(this.props.options[listIdx].value);
    }

    if (this.isMenuOpen) {
      this.hideMenu();
      if (this.props.notifyAfterClose && typeof this.props.context.onEditComplete === 'function') {
        this.props.context.onEditComplete();
      }
    }
    if (
      this.props.valKey === "client"
      || this.props.valKey === "application"
      || this.props.valKey === "selectedVersion"
    ) {
      console.error("unsupported code path");
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.clickOutsideHandler);
    document.addEventListener('ev-property-dropdown-remove', this.eventHandler);
    if (this.props.showError) {
      this.showErrorTip(this.props.errorMessage, "error")
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickOutsideHandler);
    document.removeEventListener('ev-property-dropdown-remove', this.eventHandler);
    this.hideErrorTip()
  }

  /**
   * Set the React reference of itself
   * @param {Object} node React node reference
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Hide itself if mouse click outside the boundary
   * @param {Object} event React event
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.hideMenu();
    }
  }

  resetSelection() {
    this.setState({ selection: this.initDataModel() });
    this.updateContext("");
    if (this.isMenuOpen) {
      this.hideMenu();
    }
  }

  /**
   * React render
   * @returns {XML}
   */
  render() {
    return (
      <div className={"form-component-container"}>
        {this.props.label && (
          <>
            <Label tooltip={this.props.tooltip}>{this.props.label}</Label>
            <br />
          </>
        )}
        <button className={"form-component dropdown"}
          ref={this.setWrapperRef.bind(this)}
          onClick={event => {
            if (this.state.readOnly && this.props.valKey === "moduleParameter") {
              this.showMenu();
            }
            if (!this.state.readOnly) {
              this.showMenu();
            }
          }}
        >
          <div className="dropdown-selection">
            <table>
              <tbody>
                <tr>
                  {this.state.selection !== undefined &&
                    <td className={this.state.selection.value ? "" : "no-selection "}>
                      <span className={this.props.readOnly ? "readOnly" : ""}>{this.state.selection.name}</span>
                    </td>}
                  {(() => {
                    if (!this.hasRemovable()) {
                      return null;
                    }
                    return <td className={"dropdown-remove"}
                      onClick={event => {
                        this.resetSelection();
                        event.preventDefault();
                        event.stopPropagation();
                      }}>
                      <i className={"fe icon-x"} />
                    </td>;
                  })()}
                  <td className="dropdown-icon"><i className="fe icon-chevron-down title-suffix-icon" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={"form-component dropdown-options"}>
            <div className="title">
              <table>
                <tbody>
                  <tr>
                    {(() => {
                      if (this.props.hasOwnProperty("diagramWidget") && this.props.diagramWidget) {
                        // Special case for toolbar dropdown; no search bar here
                        return <td style={{ paddingLeft: "8px" }}>{this.getOptionName()}</td>;
                      }
                      return <td><input
                        type="text"
                        placeholder={this.getOptionName()}
                        className="form-component"
                        onKeyDown={event => {
                          switch (event.keyCode) {
                            case 9:     // tab
                            case 40:    // down arrow
                              event.preventDefault();
                              $(event.currentTarget).closest(".dropdown-options").find("li:first").focus();
                          }
                        }}
                        onInput={event => {
                          this.setState({ query: this.getDomSelf().find("input").val() });
                        }}
                      /></td>;
                    })()}
                    <td className="dropdown-icon"><i
                      className="fe icon-chevron-down title-suffix-icon" /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            {this.state.selection && this.state.selection.value && (
              <div className="dropdown-current">{this.state.selection.name}</div>
            )}
            <div className="options">{(() => {
              if (this.getOptions().length <= 0) {
                return <div style={{ textAlign: "center" }}>
                  <label><em>{this.getPropLabel("no_options")}</em></label></div>;
              } else {
                var list = [];
                const regex = new RegExp(this.state.query, "i");
                const options = this.getOptions();
                options.forEach((option, i) => {
                  const disabled = option.disabled || false;
                  var op = <li
                    key={this.getOptionName() + "::" + i}
                    data-id={i}
                    tabIndex={0}
                    style={{ color: disabled ? "var(--theme-text-disabled)" : "var(--theme-text-emphasis)" }}
                    onMouseEnter={event => {
                      if ($(".link_wrapper")[0]) {
                        $(".link_wrapper")[0].innerText = "";
                        if (this.props.context.props &&
                          this.props.context.props.nodeTypeName === NodeTypeName.exit
                        ) {
                          switch (event.target.innerText) {
                            case "End Point":
                              $(".link_wrapper")[0].innerText = "Returns to the calling node in the parent module. In other words, `continue where you left off` from the parent.";
                              break;
                            case "Hand Off":
                              $(".link_wrapper")[0].innerText = "Hand off session to another application";
                              break;
                            case "Hangup":
                              $(".link_wrapper")[0].innerText = "Hangs up on the user. A system hangup."
                              break;
                            case "Return to Previous Input":
                              $(".link_wrapper")[0].innerText = "Goes back to the parent and starts again at the last InputNode it could find."
                              break;
                            case "Return to Root":
                              $(".link_wrapper")[0].innerText = "Returns to the START module for the application"
                              break;
                            case "Transfer":
                              $(".link_wrapper")[0].innerText = "Initiates a transfer of the session to the client"
                              break;
                            case "Subdialog Return":
                              $(".link_wrapper")[0].innerText = "Instructs the PE that this is the end of a subdialog. AT&T uses this extensively."
                              break;
                            case "Return to Previous Module":
                              $(".link_wrapper")[0].innerText = "Returns to the calling node in the parent module. In other words, 'continue where you left off' from the parent."
                              break;

                          }
                        }
                        if ($(".link_wrapper")[0].innerText !== "") {
                          // left is dynamic based on width of screen - left edge of Property Panel - width of ttoltip (300px) (see .link_wrapper in native.css)
                          let panelWidth = window.innerWidth - $("#right-panels").width() - 300;
                          return $(".link_wrapper")
                            .css({
                              top: event.clientY - 7,
                              left: panelWidth,
                              zIndex: 1200
                            })
                            .show();
                        }
                      }
                    }}
                    onMouseOut={() => {
                      return $(".link_wrapper").hide();
                    }}
                    onKeyDown={event => {
                      event.preventDefault();
                      switch (event.keyCode) {
                        case 9:     // tab
                          this.hideMenu();
                          $(event.currentTarget).closest(".dropdown").focus();
                          break;
                        case 13:    // enter
                          this.handleClick(event.target);
                          break;
                        case 38:    // up arrow
                          if ($(event.currentTarget).prev().length === 0) {
                            $(event.currentTarget).closest(".dropdown-options").find("input:first").focus();
                          }
                          $(event.currentTarget).prev().focus();
                          break;
                        case 40:    // down arrow
                          $(event.currentTarget).next().focus();
                          break;
                      }
                    }}
                    onClick={event => {
                      if (disabled) {
                        window.apm.notification.post("error", "Option already in use.");
                        event.stopPropagation();
                        this.hideMenu();
                      } else {
                        this.handleClick(event.target);
                        event.stopPropagation();
                      }
                    }}
                  >{option.name}</li>;
                  if (this.state.query && !option.name.match(regex)) {
                    return;
                  }
                  list.push(op);
                });

                if (list.length <= 0) {
                  return <div style={{ textAlign: "center" }}>
                    <label><em>{this.getPropLabel("no_options")}</em></label></div>;
                }
                return (<ul>{list}</ul>);
              }
            })()}</div>
          </div>
        </button>
        <div className="form-error-tip">&nbsp;</div>
      </div>
    );
  }
}
